import { useEffect } from 'react';
import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import {
  NotificationsList,
  NotificationsListItemProps,
} from '@ui/notifications/notifications-list';
import { BreadcrumbItem, Breadcrumbs } from '@heroui/react';
import { Home2 } from 'iconsax-react';
import { UserAuthorizationCard } from '@features/profile/user-authorization-card';
import { ActiveOrders } from '@features/order/active-orders';
import { ShortCuts } from '@features/profile/short-cuts';
import { UserExitButton } from '@features/profile/ui/user-exit-button.tsx';

export const NotificationsPage = () => {
  const set = useNavbar();

  const placeholder: NotificationsListItemProps[] = [
    {
      title: 'Заказ №123 - Готов к выдаче',
      description: 'Заберите заказ в удобное время.',
      hint: '10 июня, 14:32',
      isAlert: true,
    },
    {
      title: 'Новая акция в Алматы',
      description:
        'Скидка 10% на витамин C - только до конца недели! Не упустите выгодное предложение.',
      hint: '10 июня, 14:32',
      isAlert: true,
    },
  ];

  useEffect(() => {
    set.notifications();
  }, []);

  return (
    <>
      <div className="hidden lg:block container max-w-7xl mx-auto">
        <div className="hidden lg:block mt-12">
          <Breadcrumbs>
            <BreadcrumbItem href="/">
              <Home2 size="24" color="#9CA5AC" />
            </BreadcrumbItem>
            <BreadcrumbItem color="primary">Профиль</BreadcrumbItem>
          </Breadcrumbs>
        </div>

        <div className="mt-6">
          <h1 className="hidden lg:inline text-4xl text-[#222222] font-bold">
            Профиль
          </h1>
        </div>
      </div>

      <div className="hidden lg:flex flex-row container max-w-7xl mx-auto mt-12 pb-32 gap-x-12">
        <div className="w-[375px] flex flex-col">
          <UserAuthorizationCard />

          <ActiveOrders />

          <ShortCuts />

          <UserExitButton />
        </div>

        <div className="flex-grow max-w-[850px]">
          <p className="text-2xl font-semibold text-[#222222] mb-9">
            Уведомления
          </p>

          <NotificationsList items={placeholder} />
        </div>
      </div>

      <div className="h-full lg:hidden">
        <NotificationsList items={placeholder} />
      </div>
    </>
  );
};
